export default {
  // 模块名称
  cameraList: {
    // 按钮类
    button: {
      save: '保存',
      reset: '重置',
      conform: '确定',
      cancel: '取消',
      prompt: '提示',
      whole: '全选',
      export: '导出',
      import: '导入',
      moveInto: '挪入',
      moveOut: '挪出',
      moreModify: '修改相机属性',
      search: '查询',
      close: '关闭',
      back: '返回'
    },
    // 文字标签类
    label: {
      deviceName: '设备名称',
      gateName: '道闸名称',
      camerGet: '虚拟属性',
      deviceStatus: '设备状态',
      deviceId: '设备ID',
      factory: '厂家',
      areaSet: '仅显示无区域设备',
      viewDetail: '详情',
      update: '刷新状态',
      devDetail: '设备详情',
      editDevice: '编辑设备',
      moveArea: '选择移入区域',
      yes: '是',
      no: '否',
      Offline: '离线',
      Online: '在线',
      deviceSet: '设备组设置',
      areaSets: '区域设置',
      listFormat: '设备列表.xlsx',
      clickEnter: '点击进入',
      host: '主机',
      one: '个',
      etherIndoor: '是否在室内',
      buildName: '建筑物名称',
      floorCode: '楼层编码',
      deviceCode: '设备编号',
      deviceType: '设备类型',
      lng: '经度',
      buildCode: '建筑物编码',
      deviceDec: '设备描述',
      area: '所在区域',
      lat: '纬度',
      floorName: '楼层名称',
      attribute: '虚拟属性',
      doorId: '第三方设备编号',
      systemName: '系统名称',
      areaName: '区域',
      equipmentGroup: '设备组',
      statusName: '状态',
      synTime: '同步时间',
      operate: '操作',
      port: '端口',
      ip: 'IP',
      deviceVersion: '设备型号',
      statusNames: '设备状态',
      wide: '像素宽',
      high: '像素高',
      mac: 'MAC 地址',
      ipAddress: 'IP地址',
      modify: '修改',
      brake: '闸机',
      entrance: '门禁',
      alarmhost: '报警主机',
      fire: '消防',
      ipc: 'IPC',
      screen: '大屏',
      pad: 'PAD',
      parking: '停车场',
      videosis: '视频分析',
      camera: '摄像机'
    },
    // 提示类
    placeholder: {
      please: '请选择',
      enterName: '请输入设备名称',
      lengthLess: '长度小于64个字符',
      enterLng: '请输入经度',
      enterLat: '请输入纬度'
    },
    // 消息类
    message: {
      confirmSuc: '请勾选需要修改的设备',
      chooseEnter: '请选择挪入设备',
      chooseOut: '请选择移出设备',
      etherMove: '是否要挪出设备?',
      moveOut: '挪出设备',
      moveSucc: '移出设备成功',
      cancelMove: '已取消挪出',
      checkOuter: '请勾选需要导出的设备',
      fileError: '文件格式不正确',
      importSucc: '导入文件成功',
      modifySucc: '批量修改成功',
      chooseEnterArea: '请选择要挪入的区域',
      moveIntoSucc: '移入设备成功',
      numberMorn: '请输入-180~180之间,小数点最大保留10位',
      numberMorns: '请输入-90~90之间，小数点最大保留10位',
      lengthChar: '长度最多60个字符',
      lengthCharNum: '最多支持30字符，且只能是数字或字母',
      deviceLength: '请输入设备描述（字数在120字以内）'
    },
    // 标题类
    title: {
      noData: '暂无数据',
      chooseArea: '选择设备区域'
    }
  }
}
